import React, {
  Component
} from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import Modal from "../Modal";
import * as modal from "../../reducers/modalReducer";
import RaisedButton from "material-ui/RaisedButton";
import styled from "styled-components";
import {
  BODY_TEXT_COLOR,
  NEGATIVE_COLOR
} from "../../config/colors";
import {
  HeaderDiv,
  TextDiv
} from "../../modals";
import {
  getConfigValue,
  isProductsByCustomerTypeEnabled
} from "../../selectors/configSelectors";
import { updateCustomerType } from "../../actions/customer_type_actions";
import CustomerType from '../../const/customer_type';
import {
  AGE_RESTRICTION,
  CUSTOMER_TYPE_ALLOW
} from "../../config/const";
import customerTypeSelection from '../../const/customer_type'
import { getAgeByCustomerType } from "./age_util";
import { ageConfirmed } from "../../reducers/customerReducer";
import { setCustomerTypeQueryParameter } from "../../services/uri";

const styles = {
  button: { width: "180px", fontWeight: 700 },
  secondaryButtonColor: NEGATIVE_COLOR,
  labelStyle: { fontWeight: 700 }
};

class AgeConfirmModal extends Component {
  secondaryColor = ["#", this.props.secondaryColor].join("");

  state = {
    handlePositiveClick: false
  };

  onCloseRequest = () => {
    if (this.state.handleNegativeClick) return;
    this.props.hideModal();
  };

  handlePositiveClick = (customerType) => {
    const { updateCurrentCustomerType } = this.props;

    if (customerType) {
      updateCurrentCustomerType(customerType);
    }
    
    this.setState({ handlePositiveClick: true });
    this.props.ageConfirmed();
    this.props.hideModal();
  };

  handleMedicalTypeClick = () => {
    this.handlePositiveClick(CustomerType.MEDICAL);
  };

  handleAdultTypeClick = () => {
    this.handlePositiveClick(CustomerType.ADULT);
  };

  handleNegativeClick = () => {
    window.location.href = "https://google.com";
  };

  handleOfAgeClick = () => {
    this.handlePositiveClick(CustomerType.ALL);
  };

  renderCustomerTypeButtons(medicalAge, adultAge) {
    return (
      [
        <RaisedButton
          key="0"
          onClick={this.handleMedicalTypeClick}
          backgroundColor={this.secondaryColor}
          labelColor="#FFF"
          labelStyle={styles.labelStyle}
          label={`${medicalAge}+ Medical`}
          style={styles.button}
        />,
        <RaisedButton
          key="1"
          onClick={this.handleAdultTypeClick}
          backgroundColor={this.secondaryColor}
          labelColor="#FFF"
          labelStyle={styles.labelStyle}
          label={`${adultAge}+ Recreational`}
          style={styles.button}
        />,
      ]
    );
  }

  renderButtons = () => {
    const {
      ageRestriction,
      customerType,
      isProductsByCustomerTypeEnabled,
    } = this.props;

    const {
      ADULT: adultAge,
      MEDICAL: medicalAge
    } = JSON.parse(ageRestriction);

    const minimumAge = getAgeByCustomerType(adultAge, medicalAge, customerType);

    const ofAgeButton =
      <RaisedButton
        onClick={this.handleOfAgeClick}
        backgroundColor={this.secondaryColor}
        labelColor="#FFF"
        labelStyle={styles.labelStyle}
        label={`I'm ${minimumAge}+`}
        style={styles.button}
      />;

    const notOfAgeButton =
      <RaisedButton
        onClick={this.handleNegativeClick}
        backgroundColor={styles.secondaryButtonColor}
        labelColor="#FFF"
        label={`I'm NOT ${minimumAge}+`}
        labelStyle={styles.labelStyle}
        style={styles.button}
      />;

    const ofAgeAdultButton =
      <RaisedButton
        onClick={this.handleAdultTypeClick}
        backgroundColor={this.secondaryColor}
        labelColor="#FFF"
        labelStyle={styles.labelStyle}
        label={`${adultAge}+ Adult`}
        style={styles.button}
      />;

    const ofAgeMedicalButton =
      <RaisedButton
        onClick={this.handleMedicalTypeClick}
        backgroundColor={this.secondaryColor}
        labelColor="#FFF"
        labelStyle={styles.labelStyle}
        label={`${medicalAge}+ Medical`}
        style={styles.button}
      />;


    if (isProductsByCustomerTypeEnabled && customerType === customerTypeSelection.ALL) {
      return (
        <ButtonsWrapperDiv customerTypeSelection={isProductsByCustomerTypeEnabled}>
          {notOfAgeButton}
          {this.renderCustomerTypeButtons(medicalAge, adultAge)}
        </ButtonsWrapperDiv>
      );
    }

    if (customerType === customerTypeSelection.ADULT) {
      return (
        <ButtonsWrapperDiv>
          {notOfAgeButton}
          {ofAgeAdultButton}
        </ButtonsWrapperDiv>
      )
    } else if (customerType === customerTypeSelection.MEDICAL) {
      return (
        <ButtonsWrapperDiv>
          {notOfAgeButton}
          {ofAgeMedicalButton}
        </ButtonsWrapperDiv>
      )
    } else {
      return (
        <ButtonsWrapperDiv>
          {notOfAgeButton}
          {ofAgeButton}
        </ButtonsWrapperDiv>
      )
    }
  };

  render() {
    const {
      ageRestriction,
      customerType,
      isProductsByCustomerTypeEnabled
    } = this.props;

    const {
      ADULT: adultAge,
      MEDICAL: medicalAge
    } = JSON.parse(ageRestriction);

    const minimumAge = getAgeByCustomerType(adultAge, medicalAge, customerType);

    const modalText = isProductsByCustomerTypeEnabled && customerType === customerTypeSelection.ALL
      ? 'Select how you want to shop to ensure accurate product availability.'
      : `Confirm you are ${minimumAge} or older.`;

    return (
      <Modal
        overlayTop={0}
        closeOnOutsideClick={false}
        isOpened={true}
        onClose={this.onCloseRequest}
        style={{maxWidth:'600px'}}
      >
        <ModalWrapperDiv>
          <HeaderDiv>WELCOME</HeaderDiv>
          <TextDiv>
            <div>
              {modalText}
            </div>
          </TextDiv>
          {this.renderButtons()}
        </ModalWrapperDiv>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    secondaryColor: state.config.secondaryColor,
    ageGate: isNaN(state.config.AGE_GATE) ? 18 : state.config.AGE_GATE,
    isProductsByCustomerTypeEnabled: isProductsByCustomerTypeEnabled(state),
    ageRestriction: getConfigValue(state, AGE_RESTRICTION),
    customerType: getConfigValue(state, CUSTOMER_TYPE_ALLOW),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    hideModal: () => dispatch(modal.hideModal()),
    ageConfirmed: () => dispatch(ageConfirmed()),
    updateCurrentCustomerType: (customerType) => {
      dispatch(updateCustomerType(customerType));
      setCustomerTypeQueryParameter(customerType);
    }
  };
};

AgeConfirmModal.propTypes = {
  isProductsByCustomerTypeEnabled: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(AgeConfirmModal);

const ModalWrapperDiv = styled.div`
  display: flex;
  color: ${BODY_TEXT_COLOR};
  flex-direction: column;
  font-size: 18px;
  align-items: center;
  justify-content: center;
  margin: 20px auto 20px;
  height: 100%;
`;

const ButtonsWrapperDiv = styled.div`
  display: flex;
  justify-content: ${props => props.customerTypeSelection ? 'space-evenly' : 'space-between'};
  width: ${props => props.customerTypeSelection ? '600px' : '366px'};
  @media (max-width: 768px) {
    width: 355px;
    flex-direction: column;
    align-items: center;
    & > div {
      margin-bottom: 5px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/AgeConfirmModal/AgeConfirmModal.jsx